export default "__VITE_ASSET__6d4b6d17__"